import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { formatHours } from "../utils/group-time-entries";
import { NO_DIFFERENCE_LABEL } from "../utils/ad-hoc-entry";

interface EntryDifferenceBadgeProps {
  /** Null when there is no schedule to compare against. */
  difference: number | null;
  className?: string;
}

export function EntryDifferenceBadge({
  difference,
  className,
}: EntryDifferenceBadgeProps) {
  if (difference === null) {
    return (
      <span
        className={cn("text-sm text-slate-400", className)}
        aria-label="No schedule to compare"
      >
        {NO_DIFFERENCE_LABEL}
      </span>
    );
  }

  return (
    <Badge
      variant="outline"
      className={cn(
        difference > 0.1 && "bg-amber-50 text-amber-700 border-amber-200",
        difference < -0.1 && "bg-blue-50 text-blue-700 border-blue-200",
        Math.abs(difference) <= 0.1 &&
          "bg-green-50 text-green-700 border-green-200",
        className,
      )}
    >
      {difference > 0 && "+"}
      {formatHours(difference)}
    </Badge>
  );
}
